import { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

import { PageTitle } from 'src/cms/layout/core'

import DuplicateCIFCheck from './component.tsx/DuplicateCIFCheck'

import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'src/setup'
import useGetMasterDataStore from 'src/cms/hooks/get/masterData/usePostMasterData'
import { Loader } from 'rsuite'
import { ISettingTypeState } from 'src/app/modules/siteSettings/components/settings'
import { isEmpty } from 'lodash'
import moment from 'moment'
import PieChart from './component.tsx/Pie'
import { Line } from 'react-chartjs-2'
import CardComponent from './CardComponent'
// import useGetMasterData from 'src/cms/hooks/get/masterData/usePostMasterData'

const DashboardPage = ({ applicationName, gTrackCode }: any) => {
  const [gaStatus, setGaStatus] = useState(false)
  const [callApi, setCallApi] = useState(false)
  const [totalUserData, setTotalUserata] = useState<any>('')
  const [userCountryData, setUserCountryData] = useState<any>('')
  const [userUniqueData, setUserUniqueData] = useState<any>('')

  //permission management
  const { permissions } = useSelector((state: any) => {
    return state?.auth?.rolePermissions ?? []
  })

  const hasViewTotalUsersAccess =
    permissions?.findIndex((d: { name: string }) => d?.name === 'View Total Users') >= 0
  const hasViewUniqueUsersAccess =
    permissions?.findIndex((d: { name: string }) => d?.name === 'View Total Unique Users') >= 0
  const hasViewTotalUsersAroundTheWorldAccess =
    permissions?.findIndex(
      (d: { name: string }) => d?.name === 'View Total Users All Around World'
    ) >= 0

  const dispatch = useDispatch()
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)

  //primary color for charts
  const primaryColor = settingTypeData?.data?.setting?.filter((d) => d.name === 'primaryColor')[0]
    ?.value

  var curr = new Date()
  curr.setDate(curr.getDate())
  var todayDate = curr.toISOString().substr(0, 10)
  var curr1 = new Date()
  curr1.setDate(curr.getDate() - 7)
  var sevenDayBefore = curr1.toISOString().substr(0, 10)

  const [payload, setPayload] = useState({
    fromDate: sevenDayBefore,
    toDate: todayDate,
  })

  const userDeviceData: any = useSelector((state: any) => state.devices)
  const countryData: any = useSelector((state: any) => state.country)
  const uniqueData: any = useSelector((state: any) => state.unique)



  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Detail Settings']?.map((item: any) => {
          if (item?.name === 'googleAnalytics') {
            setGaStatus(item?.value === '1' ? true : false)
          }
        })
    }
  }, [settingTypeData])
  // For Pie chart
  useEffect(() => {
    const UserData = [
      {
        id: 1,
        device: 'Mobile',
        userGain: 1,
      },
      {
        id: 2,
        device: 'Desktop',
        userGain: 10,
      },
      {
        id: 3,
        device: 'Tablet',
        userGain: 20,
      },
    ]
    setUserData({
      labels: UserData?.map((data) => data.device),
      datasets: [
        {
          label: 'Users Gained',
          data: UserData?.map((data) => data.userGain),
          backgroundColor: ['#0083ba', primaryColor, '#d8f0fe'],
          borderWidth: 2,
        },
      ],
    })
    // setChartData(UserData)
  }, [userDeviceData?.data])

  const [userData, setUserData] = useState<any>()
  // useEffect(() => {
  //   service.getGuestToken().then((response) => {
  //     const token = response.data.token
  //     localStorage.setItem('guestToken', token)
  //   })
  // }, [])
  // For line Chart
  const filterDay =
    uniqueData && uniqueData?.data?.date?.map((items: any) => moment(items).format('dddd'))
  useEffect(() => {
    setData({
      labels: uniqueData?.data?.time?.length === 0 ? filterDay : uniqueData?.data?.time,

      datasets: [
        {
          label: 'No. of pageViews',
          data: uniqueData?.data?.pageViews,
          backgroundColor: 'transparent',
          borderColor: '#0083ba',
          tension: 0.4,
          fill: true,
          pointStyle: 'rect',
          pointBorderColor: '#0083ba',
          pointBackgroundColor: '#fff',
          showLine: true,
        },
        {
          label: 'No. of Unique Users',
          data: uniqueData?.data?.users,
          borderColor: primaryColor,
          backgroundColor: 'transparent',

          tension: 0.4,
          fill: true,
          pointStyle: 'rect',
          pointBorderColor: '#005b31',
          pointBackgroundColor: '#fff',
          showLine: true,
        },
      ],
    })
  }, [uniqueData?.data])

  const [data, setData] = useState<any>()
  const [open, setOpen] = useState(false)
  // const [dateRange, setDateRange] = useState<any>({})

  const [startDate, setStartDate] = useState<any>(sevenDayBefore)
  const [endDate, setEndDate] = useState<any>(todayDate)

  const toggle = () => setOpen(!open)
  const setDateRange = (dateRange: any) => {
    setStartDate(moment(dateRange.startDate).subtract(10, 'days').calendar())
    setEndDate(moment(dateRange.startDate).subtract(10, 'days').calendar())

    setPayload({
      ...payload,
      fromDate: moment(dateRange.startDate).format('YYYY-MM-DD'),
      toDate: moment(dateRange.endDate).format('YYYY-MM-DD'),
    })
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body pt-9 pb-9'>
          <span className='d-flex text-gray-800 text-hover-primary justify-content-center fs-2 fw-bolder me-1'>
            <h1> Welcome to Global IME Bank {applicationName}</h1>
          </span>

          {/* {gaStatus && ( */}
          <div>
            <div>
              {/* <DateRangeFilter /> */}{' '}
              {(hasViewTotalUsersAccess ||
                hasViewUniqueUsersAccess ||
                hasViewTotalUsersAroundTheWorldAccess) && (
                  <>
                    <div className='d-flex border border-dark cursor-pointer ' onClick={toggle}>
                      <div className='d-flex ms-5  p-3'>
                        <div>
                          {' '}
                          <h3>{payload.fromDate}</h3>{' '}
                        </div>
                        <span className='mx-4'>-</span>
                        <div>
                          {' '}
                          <h3> {payload.toDate}</h3>{' '}
                        </div>
                      </div>
                    </div>

                    {/* <DateRangePicker
                        open={open}
                        toggle={toggle}
                        onChange={(range: any) => setDateRange(range)}
                      /> */}
                  </>
                )}
              <div className='d-flex align-items-center  justify-content-center mt-2'>
                {open && (
                  <div
                    className='btn btn-success position-relative top-50'
                  // onClick={() => fetchData()}
                  >
                    ok
                  </div>
                )}
              </div>
            </div>
            {/* {!userDeviceData?.loading ? ( */}
            <>
              {hasViewTotalUsersAccess && (
                <div className=' py-4'>
                  <div className='d-flex flex-column '>
                    <div className='me-5'>
                      <h1 className='heading__component__title text-center my-3'>
                        Total Website Users
                      </h1>{' '}
                    </div>
                    <div className='row  '>
                      <div className=' col-lg-3  '>
                        <div className='border border-dark p-5 text-center'>
                          <span className='text-center '>
                            <h2>Total Users</h2>
                          </span>
                          <span>
                            ({moment(payload.fromDate).format('ll')} -{' '}
                            {moment(payload.toDate).format('ll')})
                          </span>

                          <span className='text-center'>
                            <h1>{1}</h1>
                          </span>
                        </div>
                      </div>
                      <div className=' col-lg-3'>
                        <div className='border border-dark p-5 text-center'>
                          <span className='text-center'>
                            <h2>Mobile Users</h2>
                          </span>
                          <span>
                            ({moment(payload.fromDate).format('ll')} -{' '}
                            {moment(payload.toDate).format('ll')})
                          </span>
                          <span className='text-center'>
                            <h1>{2}</h1>
                          </span>
                        </div>
                      </div>
                      <div className='col-lg-3 '>
                        <div className='border border-dark p-5 text-center'>
                          <span className='text-center'>
                            <h2>Desktop Users</h2>
                          </span>
                          <span>
                            ({moment(payload.fromDate).format('ll')} -{' '}
                            {moment(payload.toDate).format('ll')})
                          </span>

                          <span className='text-center'>
                            <h1>{3}</h1>
                          </span>
                        </div>
                      </div>
                      <div className='col-lg-3'>
                        <div className='border border-dark p-5 text-center'>
                          <span className='text-center'>
                            <h2>Tablet Users</h2>
                          </span>
                          <span>
                            ({moment(payload.fromDate).format('ll')} -{' '}
                            {moment(payload.toDate).format('ll')})
                          </span>
                          <span className='text-center'>
                            <h1>{5}</h1>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* {hasViewUniqueUsersAccess && ( */}
              <div className='row py-3 my-3'>
                {' '}
                <div className='col-lg-6 '>
                  <h1 className='ms-3 text-center heading__component__title'>
                    Active Users by Devices
                  </h1>
                  <div
                    className='border border-dark p-4 '
                    style={{ height: '500px', width: '500px' }}
                  >
                    {userData !== undefined && <PieChart chartData={userData} />}
                  </div>
                </div>
                <div className='col-lg-6 ' style={{ height: '500px' }}>
                  <h1 className='heading__component__title text-center'>Users on Website</h1>
                  {data !== undefined && <Line data={data} height={'250px'} />}
                </div>
              </div>
              {/* )} */}

              {/* {hasViewTotalUsersAroundTheWorldAccess && ( */}
              {/*  <div className='mt-5'>
                <h1 className='mt-5 heading__component__title'>Viewers over the world</h1>
                <div className='overflow-auto' style={{ height: '500px' }}>
                  <table className='table table-bordered '>
                    <thead className=' sticky-top'>
                      <tr>
                        <th scope='col'>SN</th>
                        <th scope='col'>COUNTRY</th>
                        <th scope='col'>VIEWS</th>
                        <th scope='col'>PERCENTAGE</th>
                      </tr>
                    </thead>
                    <tbody>
                      {countryData &&
                        countryData?.data?.viewers_around_world?.map((item: any) => (
                          <tr>
                            <th scope='row'>1</th>
                            <td>{item.country_name}</td>
                            <td>{item.views}</td>
                            <td>{item.percentage}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div> */}
              {/* )} */}
            </>
            {/* ) : (
                <div className='text-center mt-5'>
                  <Loader size='md' content='Loading...' />
                </div>
              )} */}
          </div>
          {/* )} */}
        </div>
      </div>
    </>
  )
}


const DashboardWrapper: FC = () => {
  const intl = useIntl()
  // const authResp = useSelector((state: any) => state.auth)
  // const {user} = authResp
  // const userRole = user?.data?.role?.name as string
  // const cardData =
  //   (DashboardCardData as DashboardCardDataIndex)[userRole] || DashboardCardData['branchmaker']
  const masterSelector = useSelector(
    (state: RootState) => state.allMasterDataOptions.allMasterDataOptions
  )
  // const { mutate } = useGetMasterDataStore()

  // useEffect(() => {
  //   mutate()
  // }, [])

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <CardComponent />
      {/* <DuplicateCIFCheck /> */}
    </>
  )
}

export { DashboardWrapper }
